const ADDITIONAL_SERVICES = [
  {
    value: 'double_driver',
    label: 'Double Driver',
  },
  {
    value: 'customs',
    label: 'Customs',
  },
  {
    value: 'adr',
    label: 'ADR',
  },
  {
    value: 'paper_invoice',
    label: 'Paper Invoice',
  },
  {
    value: 'insurance',
    label: 'Goods insurance',
  },
];

export default ADDITIONAL_SERVICES;
